import { apiRequest } from "@/lib/api";

export type PostalCodeLookupResponse = {
  postal_code: string;
  address: string;
  complement: string;
  district: string;
  city: string;
  state: string;
};

const postalCache = new Map<string, { value: PostalCodeLookupResponse; expires: number }>();

export async function lookupPostalCode(
  postalCode: string,
  signal?: AbortSignal,
  checkoutSlug?: string,
) {
  const digits = postalCode.replace(/\D/g, "");
  const path = checkoutSlug
    ? `/food/public/postal-code/${encodeURIComponent(checkoutSlug)}/`
    : `/shipping/postal-code/${encodeURIComponent(digits)}/`;
  const key = JSON.stringify([path, digits]);
  const cached = postalCache.get(key);
  if (signal?.aborted) throw new DOMException("Consulta cancelada", "AbortError");
  if (cached && cached.expires > Date.now()) return { ...cached.value };

  const value = await apiRequest<PostalCodeLookupResponse>(
    path,
    {
      method: checkoutSlug ? "POST" : "GET",
      ...(checkoutSlug ? { body: JSON.stringify({ customer_cep: digits }) } : {}),
      signal,
    },
  );
  if (value.postal_code === digits) {
    if (postalCache.size >= 32) postalCache.clear();
    postalCache.set(key, { value: { ...value }, expires: Date.now() + 300000 });
  }
  return value;
}
